import TagType from 'components-v2/organisms/pages/landingPageCam/mocules/TagType';
import { getTagRegistry, normalizeTagCodes, resolveVisibleTags } from 'utils/TagUtils';
import { useStore } from 'zustand-lib/storeGlobal';

/**
 * Hiển thị tag của sản phẩm.
 *
 * Rule đầy đủ: docs/product-tag-display-spec.md. Tóm tắt:
 *  - CMS là allow-list duy nhất: chỉ tag có trong registry và `visible = true` mới hiện (R1).
 *  - Thứ tự do `priority` của CMS quyết định, không phụ thuộc thứ tự BE trả về (R2).
 *  - Card tối đa 2 tag, phần dư bỏ (không có nút overflow) (R4, R5).
 *  - Trang chi tiết hiển thị toàn bộ tag visible (R4).
 */

// R4
const MAX_TAGS_BY_VARIANT = {
  card: 2,
  detail: Infinity,
};

const TagComponent = ({ product, variant = 'card', isGift = false, link, isLinkTagDeal }) => {
  const tags = useStore((state) => state?.tags);

  // R9: SKU quà tặng không hiển thị tag.
  if (isGift) return null;

  const visibleTags = resolveVisibleTags({
    codes: normalizeTagCodes(product?.tags),
    registry: getTagRegistry(tags),
    max: MAX_TAGS_BY_VARIANT[variant] || MAX_TAGS_BY_VARIANT.card,
  });

  if (visibleTags.length === 0) return null;

  return visibleTags.map((tag, index) => (
    <TagType key={tag.code} tag={tag} index={index} link={link} isLinkTagDeal={isLinkTagDeal} />
  ));
};

export default TagComponent;
